import { DownloadOutlined } from '@ant-design/icons';
import { ImportActionType, useImport } from 'context/import-context';
import { TActionProps } from './type';
import { MainActionButton } from './main-action-button';

export const UploadAction = ({ icon, button }: TActionProps) => {
  const { dispatch } = useImport();
  return (
    <MainActionButton
      helpText="Import Data"
      {...button}
      icon={<DownloadOutlined />}
      onClick={() => dispatch({ type: ImportActionType.IMPORT_OPEN, payload: {} })}
    />
  );
};
